import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import hydroponic_farming_Setup from "../../Assets/hydroponic_farming_Setup.png";
import { Link } from "react-router-dom";
import "animate.css";

function Hydroponic_Farming_Setup() {
  const [showImage, setShowImage] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowImage(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Container fluid>
      <div className="d-flex justify-content-center">
        <img
          src={hydroponic_farming_Setup}
          className={`card-img-top img-fluid rounded animate__animated animate__fadeInDown ${
            showImage ? "show" : ""
          }`}
          style={{
            maxWidth: "90%",
            width: "100%",
            height: "auto",
            marginTop: "20px",
          }}
          alt="hydroponic farming Setup"
        />
      </div>

      <Row className="mx-2 mx-md-5 my-4">
        <Col
          className="p-3 text-justify"
          sm={12}
          md={9}
          style={{
            fontSize: "1rem",
            lineHeight: "1.6",
            color: "#333",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px",
          }}
        >
          <div style={{ padding: "20px" }}>
            <h1 className="text-center pb-3">Hydroponic Farming Setup</h1>

            <p>
              <span className="fw-bold">
                Want to grow fresh vegetables without soil? Hydroponic farming
                is your answer.
              </span>{" "}
              Whether you're starting a home garden or planning a commercial
              hydroponic farm, this detailed guide will walk you through every
              step of setting up a successful hydroponic system.
            </p>

            <h4>What is a Hydroponic Farming Setup?</h4>
            <p>
              A{" "}
              <a href="https://royalgreenhouse.co.in/hydroponic-farming-in-india">
                hydroponic farming setup
              </a>{" "}
              is a method of growing crops without soil, using nutrient-rich
              water solutions to deliver essential minerals directly to plant
              roots. It is a sustainable, water-efficient, and space-saving
              approach that enables year-round cultivation, faster plant growth,
              and higher yields.
            </p>

            <h4> Step-by-Step Guide to Setting Up a Hydroponic Farm</h4>
            <ol>
              <li>Choose the Right Hydroponic System</li>
              <p>
                Your setup begins by selecting a system that matches your crop
                type, budget, and available space.
                <div className="table-responsive">
                  <table className="table table-bordered border-dark">
                    <thead className="thead-dark">
                      <tr>
                        <th>Hydroponic System</th>
                        <th>Best For</th>
                        <th> Highlights</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <a href="https://royalgreenhouse.co.in/nft-a-frame">
                            NFT (Nutrient Film Technique)
                          </a>
                        </td>
                        <td>Leafy greens</td>
                        <td> Water flows in a thin film over roots</td>{" "}
                      </tr>
                      <tr>
                        <td>
                          <a href="https://royalgreenhouse.co.in/dwc">
                            DWC (Deep Water Culture)
                          </a>
                        </td>
                        <td> Beginners</td>
                        <td>
                          Plants float in oxygenated nutrient solution
                        </td>{" "}
                      </tr>
                      <tr>
                        <td>
                          <a href="https://royalgreenhouse.co.in/dutch-bucket">
                            Dutch Bucket System
                          </a>
                        </td>
                        <td>Fruiting crops</td>
                        <td> Ideal for tomatoes, cucumbers, capsicum</td>{" "}
                      </tr>
                      <tr>
                        <td>Vertical Farming</td>
                        <td> Small spaces</td>
                        <td> Uses vertical racks, ideal for cities</td>{" "}
                      </tr>
                      <tr>
                        <td>
                          <a href="https://royalgreenhouse.co.in/grow-bag">
                            Grow Bags & Slabs
                          </a>
                        </td>
                        <td> Commercial farms</td>
                        <td> Cost-effective for herbs & leafy greens</td>{" "}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </p>
              <li>Plan the Layout of Your Hydroponic Farm</li>
              <p>
                Design a layout that ensures easy access, proper spacing, and
                maximum light exposure.
                <ul>
                  Indoor Setup:
                  <li>
                    Use
                    <span className="fw-bold">LED grow lights</span> fans, and
                    dehumidifiers
                  </li>
                  <li>Consider grow tents for temperature control</li>
                </ul>
                Outdoor/Greenhouse Setup:
                <ul>
                  <li>
                    Use{" "}
                    <a href="https://royalgreenhouse.co.in/nvph">polyhouse</a>{" "}
                    or{" "}
                    <a href="https://royalgreenhouse.co.in/flat-shade-net-house">
                      net house
                    </a>{" "}
                    structures to regulate climate
                  </li>
                  <li>
                    Protect from pests, excess rain, and extreme temperatures
                  </li>
                  Include in your layout:
                  <ul>
                    <li>Clear pathways for movement</li>
                    <li>Efficient drainage system</li>
                    <li>Light and air flow access to all plants</li>
                  </ul>
                </ul>
              </p>
              <li>Set Up Water & Nutrient Circulation System</li>
              <p>
                A reliable irrigation and nutrient system is crucial for plant
                health.
                <ul>
                  Essential Components:
                  <li>
                    <span className="fw-bold">Reservoir tank</span> to store
                    nutrient solution
                  </li>
                  <li>
                    <span className="fw-bold">Submersible pump</span> for water
                    flow
                  </li>
                  <li>
                    <span className="fw-bold">Irrigation channels</span> (PVC
                    pipes or trays)
                  </li>
                  <li>
                    <span className="fw-bold">pH & EC meters</span>to monitor
                    solution strength
                  </li>
                  Ideal Ranges:
                  <ul>
                    <li>
                      <span className="fw-bold">pH:</span>Between 5.5–6.5
                    </li>
                    <li>
                      <span className="fw-bold">EC/TDS:</span>Crop-specific
                      (lettuce: ~700–1000 ppm)
                    </li>
                  </ul>
                </ul>
              </p>
              <li>Select Growing Media & Crops</li>
              <p>
                Since there’s no soil, you need a neutral, sterile growing
                medium to support plant roots.
                <ul>
                  <li>
                    <span className="fw-bold">Cocopeat + perlite:</span>{" "}
                    Affordable and effective
                  </li>

                  <li>
                    <span className="fw-bold">LECA (clay pebbles):</span>–
                    Reusable, excellent drainage
                  </li>

                  <li>
                    <span className="fw-bold">Rockwool:</span>Great for seed
                    starting
                  </li>
                </ul>
                Best crops for beginners:
                <ul>
                  <li>Leafy Greens: Lettuce, Kale, Spinach</li>

                  <li>Herbs: Basil, Mint</li>

                  <li>Fruits: Strawberries</li>

                  <li>
                    <a href="https://royalgreenhouse.co.in/top10-hydroponic-plants-for-india">
                      Exotic Crops for Hydroponics in India
                    </a>
                  </li>
                </ul>
              </p>
              <li>Automate and Monitor (Optional but Recommended)</li>
              <p>
                Automation enhances efficiency and reduces labor.
                <ul>
                  <li>
                    <span className="fw-bold">Timers</span> for pumps and lights
                  </li>

                  <li>
                    <span className="fw-bold">Sensors</span> for temperature,
                    humidity, pH, and EC
                  </li>

                  <li>
                    <span className="fw-bold">Dosing systems</span> for
                    nutrients
                  </li>

                  <li>
                    <span className="fw-bold">Mobile apps</span> for real-time
                    tracking
                  </li>
                </ul>
                Benefits:
                <ul>
                  <li>Reduces manual labor</li>

                  <li>Improves plant health</li>

                  <li>Saves water and energy</li>
                </ul>
              </p>
              <li>
                {" "}
                Expert Tips for Beginners
                <p>
                  <ul>
                    <li>Start small before scaling to commercial size</li>
                    <li>Monitor daily: water levels, pH, temperature</li>
                    <li>Keep the growing area clean and sterile</li>
                    <li>Always research crop-specific nutrient needs</li>
                    <li>Use RO or filtered water to avoid mineral buildup</li>
                  </ul>
                </p>
              </li>
            </ol>
            <p>
              With the growing need for sustainable, pesticide-free food
              production, hydroponics offers an eco-friendly and efficient
              farming method for the modern world.
            </p>
            <p>
              Whether you're a hobbyist or an entrepreneur, a well-planned
              hydroponic farming setup can generate consistent yields and
              profits while conserving water and space.
            </p>
            <h4>Want to Set Up Your Own Hydroponic Farm?</h4>
            <p>
              At Royal Green House Construction (I) Pvt. Ltd., we provide:
              <ul>
                <li>Customized design</li>
                <li>System installation</li>
                <li>Training and consultancy</li>
                <br></br>
                📩 Contact us: <a href="tel:+919960991166"> +91-9960-991-166</a>
                <br></br>
                🌐 Visit:{" "}
                <a href="www.royalgreenhouse.co.in">
                  {" "}
                  www.royalgreenhouse.co.in
                </a>
              </ul>
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Hydroponic_Farming_Setup;
